import { render } from "./ModalDocumentSend.vue?vue&type=template&id=17884bc1&scoped=true"
import script from "./ModalDocumentSend.vue?vue&type=script&lang=js"
export * from "./ModalDocumentSend.vue?vue&type=script&lang=js"

import "./ModalDocumentSend.vue?vue&type=style&index=0&id=17884bc1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17884bc1"]])

export default __exports__